<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog()" header="Extend Date" size="md">
        <span slot="body">
            <h3>Extend Date For Assignment Nr: {{assignmentNumber}}</h3>

            <div *ngIf="isAllowedToEditExtendDate()">
                <div class="tds-col-xs-12 tds-u-mb1" *ngIf="showDeleteSymbol()">
                    <tds-button
                        type="submit"
                        variant="danger"
                        size="sm" 
                        text="Delete extend date"
                        title="Delete the current date set (Note: The assignment will no longer be extended.)"
                        (click)="removeAssignmentExtendDate()">
                        <tds-icon slot="icon" class="tds-btn-icon" size="16px" name="trash"></tds-icon>
                    </tds-button>
                </div>

                <div class="tds-row ">
                    <div class="tds-col-xs-8">
                        <tds-datetime
                            [(ngModel)]="extendtoDate"
                            ngDefaultControl
                            id="datetime"
                            type="date"
                            size="sm"
                            state="none"
                            label="Set extend date">
                        </tds-datetime>
                    </div>
                    <div class="tds-col-xs-4 tds-u-mt3 ">
                        <tds-button
                            type="submit"
                            variant="primary"
                            size="sm"
                            text="Submit"
                            [disabled]="!isValuesSet()"
                            (click)="setAssignmentExtendDate()">
                            <tds-icon slot="icon" class="tds-btn-icon" size="20px" name="send"></tds-icon>
                        </tds-button>
                    </div>
                </div>
            </div>

            <h4>History</h4>

            <div *ngIf="logChangesList.length > 0" style="height: 264px;overflow-y: scroll;">
                <div *ngFor="let edit of logChangesList">
                    <div style="margin-bottom: 12px; color: #041e42">
                        <h4 style="position: relative;">{{edit.name}} ({{edit.globalId}})</h4>
                        <div><strong>{{edit.department}}</strong></div>
                        <div><strong>{{edit.role}}</strong></div>
                        <div><strong>{{edit.email}}</strong></div>
                        <div><strong>{{edit.occurred | date:'medium'}}</strong></div>
                    </div>
                    <div style="width: 100%;">
                        <div>Edit Type: <u>{{edit.action}}</u></div>
                        <div>Value Before Edit: <span style="color: red;">{{getDateString(edit.changedFrom)}}</span></div>
                        <div>Value After Edit: <span style="color: green;">{{getDateString(edit.changedTo)}}</span></div>
                    </div>
                    <hr>
                </div>
            </div>
            <div *ngIf="logChangesList?.length == 0 && !showLoading">No History To Show.</div>
            <div *ngIf="showLoading" class="page-spinner-container" >
                <div class="page-spinner tds-headline-06 ">
                    <tds-spinner size="lg" variant="standard" style="margin-top: 64px;"></tds-spinner>
                </div>      
            </div>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Close"
                (click)="closeDialog()">
            </tds-button>
        </span>
    </tds-modal>
</div>